import { CampaignCartItemDto, CartItemsDto, ProductCartItemDto } from 'src/types/generated';

import BaseApiModule from 'src/api/base';

interface IVerifyCartItemsResponse {
  verified: CartItemsDto;
  unverified: CartItemsDto;
}

export type ICartItem = Partial<ProductCartItemDto & CampaignCartItemDto> & {
  isVoucherFreeProduct?: boolean;
};

class CartApi extends BaseApiModule {
  protected baseRoute = '/cart';

  public async verifyCartItems(model: ICartItem[]): Promise<{
    verifiedCartItems: ICartItem[];
    unverifiedCartItems: ICartItem[];
  }> {
    // Free products are managed by voucher system, not availability — skip API validation
    const freeProducts = model.filter((c) => c.isVoucherFreeProduct);
    const itemsToVerify = model.filter((c) => !c.isVoucherFreeProduct);

    const { verified, unverified } = (await this._post<IVerifyCartItemsResponse>(
      `${this.baseRoute}/verify-cart-items`,
      {
        productItems: itemsToVerify.filter((c) => c.isProduct) as ProductCartItemDto[],
        campaignItems: itemsToVerify.filter((c) => c.isCampaign) as CampaignCartItemDto[],
      }
    )) || {
      verified: { productItems: [], campaignItems: [] },
      unverified: { productItems: [], campaignItems: [] },
    };
    return {
      verifiedCartItems: [...verified.campaignItems, ...verified.productItems, ...freeProducts],
      unverifiedCartItems: [...unverified.campaignItems, ...unverified.productItems],
    };
  }
}

export default CartApi;
